import { PropTypes } from "prop-types";

export const FileShape = {
    url: PropTypes.string.isRequired,
    alternativeText: PropTypes.string,
    name: PropTypes.string,
};

export default FileShape;
